import {
    SABox,
    SAButton,
    SACard,
    SAColumns
} from "@saux/design-system-react";
import "./MyOutofOffice.css";
import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import snackbarOpen from "../../store/action-creators/snackbarActionCreators";
import { createOutOfficeStatus, deleteOutofOfficeStatus, getOutofOfficeStatus, updateOutOfficeStatus } from "../../store/actions/userActions";
import {
    CLEAR_MESSAGE,
    CONFIRM_MESSAGE,
    DATE_ERROR,
    ENDDATE_ERROR,
    OOO_MESSAGEERROR,
    OOO_TITLE,
    SNACKBAR,
    STARTDATE_ERROR,
    TURNOFF_LABEL,
} from "../../utils/constants";
import Switch from "react-switch";
import { SADatePicker } from "../DatePicker/DatePicker";
import { Icon } from '../Icon/Icon';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { SATextField } from "../TextField/TextField";
import { simpleGTMDataLayer } from "../../utils/utilities";
import { isNull } from "lodash";
import styled from "styled-components";
import { Modal } from "../../styles/Modal.style";
import { Grid } from "@material-ui/core";

const ConfirmCard = styled(SACard)`
    margin: 25px;
    width: 30%;
    height: fit-content;
    background-color: white;
    margin: auto;
    margin-top: 10%;
    border-radius: 8px;
    padding: 35px 15px 0;
  `;

  const LoaderModal = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;


export default function MyOutofOffice(props: any) {
    const user = useSelector((state: any) => state.user);
    let outOfOfficeInfo = {
        ...user.outOfOfficeStatus
    };
    const [isOutofOffice, setOutofOffice] = useState(props.outOfOffice?.outOfOfficeStatus === "enabled" ? true : false);
    const [message, setMessage] = useState((outOfOfficeInfo.message !== undefined ? outOfOfficeInfo.message : ""));
    const [flag, setFlag] = useState(props?.outOfOffice?.outOfOfficeStatus === "enabled" ? "display" : "");
    const [oofStartDate, setoofStartDate] = useState<Date | null>(outOfOfficeInfo.startDate !== (undefined || null) ? new Date(outOfOfficeInfo.startDate) : null);
    const [oofEndDate, setoofEndDate] = useState<Date | null>(outOfOfficeInfo.endDate !== (undefined || null) ? new Date(outOfOfficeInfo.endDate) : null);
    const [errorStartDate, setErrorStartDate] = useState<boolean>(false);
    const [errorEndDate, setErrorEndDate] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({ startDate: false, endDate: false, message: false });
    const [disable, setDisabled] = useState<boolean>(false);
    const [confirmBox, setConfirmBox] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const dispatch = useDispatch();

    useLayoutEffect(()=>{
        setLoader(true);
        dispatch(getOutofOfficeStatus({adjusterId:user?.email},  (res: any) => {
         // console.log(res);
          res.outOfOfficeStatus === "enabled" ?setOutofOffice(true):setOutofOffice(false);
          res.outOfOfficeStatus === "enabled" ? setFlag("display") : setFlag("");
          setMessage(res.message);
          res.startDate !== (undefined || null) ? setoofStartDate(new Date(res.startDate)):setoofStartDate(null);
          res.endDate !== (undefined || null) ?setoofEndDate(new Date(res.endDate)):setoofEndDate(null);
          outOfOfficeInfo=res;
          setLoader(false);
        }));
      },[]);  

    const handleSwitchChange = (e: any) => {
        setOutofOffice(e);
        if (e === true) {
            setFlag("new");
        }
        else {
            if (outOfOfficeInfo?.outOfOfficeStatus === "enabled") {
                setOutofOffice(true);
                setConfirmBox(true);
            }
            else {
                setoofEndDate(null);
                setoofStartDate(null);
                setErrorStartDate(false);
                setErrorEndDate(false);
                setErrorMessage(false);
                setFlag("");
            }
        }
    };

    const clearOutofOfficeStatus = () => {
        let deleteOutofOfficeInput: any = {
            adjusterId: user?.email,
            id: outOfOfficeInfo?.id
        }
        dispatch(deleteOutofOfficeStatus(deleteOutofOfficeInput,
            (response: any) => {
                console.log(response);
                props.setDefaultIndex(0);
                props.setDisplayModal(false);
                setoofEndDate(null);
                setoofStartDate(null);
                setMessage(null);
                setErrorStartDate(false);
                setErrorEndDate(false);
                setErrorMessage(false);
                dispatch(getOutofOfficeStatus({ adjusterId: user?.email }));
                dispatch(
                    snackbarOpen({
                        open: true,
                        title: "Out of Office Status",
                        message: CLEAR_MESSAGE,
                        type: SNACKBAR.SUCCESS,
                    })
                );
            }));
    }


    const handleOutofOfficeCancel = () => {
        props.setDefaultIndex(0);
        props.setDisplayModal(false);
    };

    const getFormattedDate = (date: any) => {
        if (!isNull(date)) {
            var year: any = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;

            return month + '/' + day + '/' + year;
        }
    }

    const handleOutofOfficeSave = () => {
        if (!oofStartDate || !oofEndDate || !message) {
            !oofStartDate ? setErrorStartDate(true) : setErrorStartDate(false);
            !oofEndDate ? setErrorEndDate(true) : setErrorEndDate(false);
            !message ? setErrorMessage(true) : setErrorMessage(false);
        }
        else if (oofStartDate > oofEndDate) {
            dispatch(snackbarOpen({ open: true, message: DATE_ERROR, type: SNACKBAR.ERROR }))
        }
        else {
            createOutofOfficeStatus();
        }
    };

    const createOutofOfficeStatus = () => {
        if (flag === "edit") {
            let updateOutofOfficeInput: any = {
                adjusterId: user?.email,
                id: outOfOfficeInfo?.id,
                startDate: getFormattedDate(oofStartDate),
                endDate: getFormattedDate(oofEndDate),
                message: message
            }
            dispatch(updateOutOfficeStatus(updateOutofOfficeInput,
                (response: any) => {
                    props.setDefaultIndex(0);
                    props.setDisplayModal(false);
                    //dispatch(getOutofOfficeStatus({ adjusterId: user?.email }));
                    dispatch(
                        snackbarOpen({
                            open: true,
                            title: "Out of Office Status",
                            message: `Updated Out of Office Status for ${updateOutofOfficeInput.startDate} to ${updateOutofOfficeInput.endDate}.`,
                            type: SNACKBAR.SUCCESS,
                        })
                    );
                }));
        }
        else {
            let createOutofOfficeInput: any = {
                adjusterId: user?.email,
                startDate: getFormattedDate(oofStartDate),
                endDate: getFormattedDate(oofEndDate),
                message: message
            }

            dispatch(createOutOfficeStatus(createOutofOfficeInput,
                (response: any) => {
                    props.setDefaultIndex(0);
                    props.setDisplayModal(false);
                    dispatch(
                        snackbarOpen({
                            open: true,
                            title: "Out of Office Status",
                            message: `Created new Out of Office Status for ${createOutofOfficeInput.startDate} to ${createOutofOfficeInput.endDate}.`,
                            type: SNACKBAR.SUCCESS,
                        })
                    );
                }));
        }
    }

    const handleEditDetails = () => {
        setFlag("edit");
        setDisabled(true);
    }

    const startDateChange = (date: Date) => {
        setoofStartDate(date);
        setErrorStartDate(false);
        if (flag === "edit") {
            validatedChanges(date, oofEndDate, message);
        }
    };

    const endDateChange = (date: Date) => {
        setoofEndDate(date);
        setErrorEndDate(false);
        if (flag === "edit") {
            validatedChanges(oofStartDate, date, message);
        }
    };

    const handleMessage = (e: any) => {
        setMessage(e.target.value);
        if (e.target.value !== "" || e.target.value !== null) {
            setErrorMessage(false);
        }

        if (flag === "edit") {
            validatedChanges(oofStartDate, oofEndDate, e.target.value);
        }
    };

    const validatedChanges = (startDt: any, endDt: any, msg: any) => {
        if ((props?.outOfOffice?.startDate !== getFormattedDate(startDt)) || (props?.outOfOffice?.endDate !== getFormattedDate(endDt)) || (props?.outOfOffice?.message !== msg)) {
            setDisabled(false);
        }
        else {
            setDisabled(true);
        }
    }

    const modalHandler = (event: React.MouseEvent) => {
        event.stopPropagation();
    };


    return (
        <>
        {loader && (
            <LoaderModal>
              <Grid container alignItems="center" style={{ height: "80vh" }}>
                <Grid
                  container
                  justify="flex-end"
                  direction="row"
                  alignItems="center"
                >
                  <Grid item xs={12}>
                    <div className="loader" />
                  </Grid>
                </Grid>
              </Grid>
            </LoaderModal>
          )}
    
      { !loader && <div data-testid="my-outofOffice" style={{ marginLeft: "5%", marginRight: "5%" }}>
            <br />
            <SABox display="inline">
                <SAColumns columns={[3]} spacing="medium">
                    <SABox px="medium" py="medium" data-testid="title">
                        <span id="oooLabel">
                            Out of Office
                        </span>
                    </SABox>
                    <SABox px="small" py="small" data-testid="toggle-ooo" display="inline">
                        <SAColumns columns={[1]} spacing="xs">
                            <Switch
                                onChange={handleSwitchChange}
                                checked={isOutofOffice}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                onColor="#0173C6"
                                offColor="#666666"
                                height={25}
                                width={45}
                                borderRadius={25}
                                data-testid="ooo-switch"
                            />
                            {(flag === "display" || flag === "edit") && <span id="turnOffMsg">
                                {TURNOFF_LABEL}
                            </span>}
                        </SAColumns>
                    </SABox>
                </SAColumns>
            </SABox>
            {(isOutofOffice && flag === "edit") || flag === "new" ?
                <div>
                    <SABox display="flex" marginTop={"small"}>
                        <div id="inputStartDt">
                            <SADatePicker
                                id="startDate"
                                data-testid="startdate"
                                label="Out of Office Start Date"
                                value={oofStartDate}
                                onChange={startDateChange}
                                keyboardIcon={<Icon name="calendar" />}
                                onBlur={() => oofStartDate ? setErrors({ ...errors, startDate: false }) : setErrors({ ...errors, startDate: true })}
                                error={errorStartDate}
                                helperText={errorStartDate ? STARTDATE_ERROR : undefined}
                                shouldDisableDate={(day: MaterialUiPickersDate) =>
                                    (day &&
                                        (day.getTime() <= Date.now() - 86400000)) ||
                                    false
                                }
                            />
                        </div>
                        <div id="inputEndDt">
                            <SADatePicker
                                id="endDate"
                                data-testid="enddate"
                                label="Out of Office End Date"
                                value={oofEndDate}
                                onChange={endDateChange}
                                keyboardIcon={<Icon name="calendar" />}
                                onBlur={() => oofEndDate ? setErrors({ ...errors, endDate: false }) : setErrors({ ...errors, endDate: true })}
                                error={errorEndDate}
                                helperText={errorEndDate ? ENDDATE_ERROR : undefined}
                                shouldDisableDate={(day: MaterialUiPickersDate) =>
                                    (day &&
                                        (day.getTime() <= Date.now() - 86400000)) ||
                                    false
                                }
                            />
                        </div>
                    </SABox>
                    <div style={{ marginTop: "2%" }}>
                        <SATextField
                            label="Out of Office Message"
                            id={`OutofOfficeMessage`}
                            data-testid="msg"
                            InputLabelProps={{ "aria-labelledby": "OutMessage" }}
                            style={{
                                fontFamily: "Lato",
                                fontSize: "16px",
                                lineHeight: "20.8px",
                            }}
                            onChange={handleMessage}
                            multiline
                            showCharacterCount
                            minRows={7}
                            maxRows={7}
                            characterLimit={500}
                            value={message}
                            onBlur={() => !message ? setErrors({ ...errors, message: true }) : setErrors({ ...errors, message: false })}
                            error={errorMessage}
                            helperText={errorMessage ? OOO_MESSAGEERROR : undefined}
                        /></div>

                    <SABox display="flex">
                        <SAButton
                            id="cancelBtn"
                            label="cancel"
                            data-testid="cancel"
                            name="cancel"
                            variant="small"
                            onClick={handleOutofOfficeCancel}
                        />
                        <SAButton
                            id="saveBtn"
                            label="save"
                            data-testid="save"
                            name="save"
                            variant="small"
                            onClick={handleOutofOfficeSave}
                            disabled={disable}
                        />
                    </SABox></div>
                : flag === "display" ?
                    <SABox marginLeft={"xs"}>
                        <SABox marginBottom={"medium"} marginTop={"medium"}>
                            <div style={{ alignItems: "center" }}>
                                <span id="currentOOO">
                                    {OOO_TITLE}
                                </span>

                                <SAButton
                                    id="editBtn"
                                    label="Edit"
                                    variant="small"
                                    onClick={handleEditDetails}
                                /></div>

                        </SABox>

                        <SABox marginBottom={"small"}>
                            <span id="dateTitle">
                                START DATE:
                            </span>
                            <span id="dateInfo">
                            {outOfOfficeInfo.startDate}
                            </span>
                        </SABox>
                        <SABox marginBottom={"small"}>
                            <span id="dateTitle">
                                END DATE:
                            </span>
                            <span id="dateInfo">
                            {outOfOfficeInfo.endDate}
                            </span>
                        </SABox>
                        <SABox>
                            <p id="message">
                            {outOfOfficeInfo.message}
                            </p>  </SABox>

                    </SABox> : ""
            }

            {confirmBox && (
                <Modal onClickHandler={(event: React.MouseEvent) => modalHandler(event)}>
                    <ConfirmCard variant="minimal">
                        <h3>{CONFIRM_MESSAGE}</h3>
                        <SACard variant="sub-titled" />
                        <SABox display="flex">
                            <SAButton
                                id="noBtn"
                                label="No"
                                variant="small"
                                onClick={() => { setConfirmBox(false); }}
                            />
                            <SAButton
                                id="yesBtn"
                                label="Yes"
                                variant="small"
                                onClick={clearOutofOfficeStatus}
                            />
                        </SABox>
                    </ConfirmCard>
                </Modal>
            )}
        </div>}</>
    );
}

